import React, { Component } from 'react';

import { Input, Button, Errors } from '../components';
import { Routes as routes } from '../navigation';
import '../css/LinkNewPractice.css';

class LinkNewPractice extends Component {

  constructor(props) {
    super(props);

    let defaultRoles = {
      vet: false,
      tech: false,
      behaviorist: false,
      practice_owner: false,
      practice_manager: false,
    }

    this.state = {
      practiceCode: '',
      searchedPracticeResult: null,
      searchedPracticeSelected: false,
      selectedPracticeRoles: defaultRoles,
      atLeastOneRoleSelected: false,
      validation: {},
    }
  }

  renderRoleOptions = (practice, selected) => {
    if (!practice || !selected) {
      return null;
    }

    var newPracticeAdminRoles = [];

    if (practice.type === 'MEDICAL') {
      newPracticeAdminRoles.push({ role: 'vet', label: 'Veterinarian' });
    }

    if (practice.type === 'BEHAVIOR') {
      newPracticeAdminRoles.push({ role: 'behaviorist', label: 'Behaviorist' });
    }

    newPracticeAdminRoles.push({ role: 'tech', label: 'Tech' });
    newPracticeAdminRoles.push({ role: 'practice_manager', label: 'Practice Manager' });
    newPracticeAdminRoles.push({ role: 'practice_owner', label: 'Practice Owner' });

    const roleButtons = newPracticeAdminRoles.map((role) => {
      return <input type="submit"
                    key={role.role}
                    value={role.label}
                    className="button-clear"
                    style={{ margin: 5, marginLeft: 0, marginRight: 10, color: this.state.selectedPracticeRoles[role.role] ? '#1dc2ff' : '', backgroundColor: this.state.selectedPracticeRoles[role.role] ? '#e8f8ff' : '' }}
                    onClick={ () => {
                      var currentSelectedRoles = this.state.selectedPracticeRoles;
                      var allKeys = Object.keys(currentSelectedRoles);

                      currentSelectedRoles[role.role] = !currentSelectedRoles[role.role];
                      var atLeastOneSelected = false;

                      allKeys.forEach((key) => {
                        if(currentSelectedRoles[key] === true) {
                          atLeastOneSelected = true;
                        }
                      })

                      this.setState({ ...this.state, selectedPracticeRoles: currentSelectedRoles, atLeastOneRoleSelected: atLeastOneSelected });
                    }}
                  />
    })

    return <div style={{ marginTop: 15 }}>
      <div style={{ fontSize: 13, color: '#1dc2ff' }}>SELECT YOUR ROLE(S)</div>
      { roleButtons }
      { this.state.atLeastOneRoleSelected ? <div className='flex-container-column' style={{ alignItems: 'flex-end'}}>
                                                <input  type="submit"
                                                    value="Send Request to Link"
                                                    className="button-default"
                                                    style={{ marginTop: 10 }}
                                                    onClick={ () =>{ this.sendLinkRequest() }}
                                                  />
                                            </div>
                                          : null }
    </div>
  }

  renderPracticeInfo = (practiceInfo)  => {

    if (!practiceInfo) {
      return null;
    }

    const roles = this.props.roles || {};
    const practice = practiceInfo;

    if (roles && roles[practice._id] && roles[practice._id].approved === true) {
      return <div style={{ marginTop: 10 }}>
        <span>You are already linked with { practice.name }</span>
      </div>
    }

    if (roles && roles[practice._id] && roles[practice._id].approved === false) {
      return <div>
        <span>You already have a pending request to link with { practice.name }</span>
      </div>
    }

    return <div style={{ marginTop: 15 }}>
      <div className={`link-practice-row-container ${this.state.searchedPracticeSelected ? 'link-practice-row-container-selected' : ''}`}
            onClick={ () => { this.setState({ ...this.state, searchedPracticeSelected: !this.state.searchedPracticeSelected }) }}
            >
        <span>{ practice.name }</span>
        <span style={{ fontSize: 14, marginRight: 15, color: '#1dc2ff' }}>Link</span>

      </div>
      { this.renderRoleOptions(practice, this.state.searchedPracticeSelected) }
    </div>
  }

  renderLinkNewPractice = () => {
    return <div className="basic-container" style={{ paddingBottom: 30 }}>
      <h4 style={{ marginBottom: 20 }}>Link With a Practice</h4>
      <div>
        <Input style={{ width: 230, marginRight: 20 }}
               placeholder="Enter Practice Code"
               value={this.state.practiceCode}
               invalid={this.state.validation.fields && this.state.validation.fields['practiceCode']}
               onChange={ (event) => { this.setState({ ...this.state, practiceCode: event.target.value }) }}
              />
        <Button value="Search"
                className="button-default"
                loading={this.props.loading && this.props.loading.searchPracticeCode}
                onClick={ () => {
                  if (!this.state.practiceCode) {
                    const validation = {
                      fields: { 'practiceCode': true },
                      errors: [ 'No Code Entered' ],
                    }
                    this.setState({ ...this.state, validation: validation });
                  } else {
                    this.setState({ ...this.state, validation: {} });
                    this.props.userActions.fetchExistingPractice(this.state.practiceCode, this.processSearchedResult)
                  }
                }}
              />
      </div>
      <Errors validation={this.state.validation} />
      { this.renderPracticeInfo(this.state.searchedPracticeResult) }
    </div>
  }

  render() {
    return this.renderLinkNewPractice();
  }

  sendLinkRequest = () => {
    const token = this.props.token;
    const user_id = this.props.user && this.props.user._id ? this.props.user._id : '';
    const practice = this.state.searchedPracticeResult;
    const roles = this.state.selectedPracticeRoles;

    if (token && practice && roles && this.state.atLeastOneRoleSelected) {
      this.props.userActions.sendJoinRequestToPractice(user_id, practice, roles, token, this.successCallback)
    }
  }

  processSearchedResult = (practiceInfo) => {
    if (!practiceInfo) {
      // No Practice Found
    }
    if (practiceInfo) {
      var selectedLocations = {};
      if (practiceInfo.locations && practiceInfo.locations.length === 1) {
        selectedLocations[practiceInfo.locations[0]._id] = true;
      }
      this.setState({
        ...this.state,
        searchedPracticeResult: practiceInfo,
      });
    }
  }

  successCallback = () => {

    let defaultRoles = {
      vet: false,
      tech: false,
      behaviorist: false,
      practice_owner: false,
      practice_manager: false,
    }

    this.setState({
      practiceCode: '',
      searchedPracticeResult: null,
      searchedPracticeSelected: false,
      selectedPracticeRoles: defaultRoles,
      atLeastOneRoleSelected: false,
    })
  }

}


export default LinkNewPractice
